import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { Router } from "@angular/router";
import { DataService } from "../data.service";
import { CONFIG } from '../config';
import { AccountService } from '../@tools/account';


@Component({
    selector: 'app-root',
    templateUrl: './root.component.html',
    styleUrls: ['./root.component.scss']
})
export class RootComponent implements OnInit {

    CONFIG = CONFIG;
    user;
    url;

    constructor(private route: ActivatedRoute, private router: Router, private DATA: DataService, private account: AccountService) {
        account.current.then(user => {
            this.user = user;
        });

        this.url = CONFIG.url;
    }

    ngOnInit() {
    }

    logout() {
        this.account.logout();
    }

    defaultOrder() {
        return 0;
    }

}
